<template>
  <div class="card-content"
       :class="[ demande.avertissement ? 'background-error-table' : 'has-background-background']">
    <div class="columns is-multiline">
      <div class="column is-narrow mgv-auto width-65px">
        <qd-checkbox :value="demande.selected"
                    @input="$emit('updateSelected', [demande.ligneId], !demande.selected)">
        </qd-checkbox>
      </div>
      <div class="column is-2">
        <div class="columns is-multiline is-marginless">
          <div class="column is-narrow is-paddingless">
            <div class="has-text-weight-bold is-min-width-240 is-size-5">
              {{ demande.libelleProduit }}
            </div>
            <span class="has-text-link ellipsis">
                {{ getAnneeSemaine(demande.anneeSemaine) }}
            </span>
            <p>
              <span class="has-text-default is-italic">
                {{ $t('listeDemandeTempo.card.face') }}
              </span>
              <span class="has-text-weight-bold has-text-link">
                {{ demande.qteFacesSouhaitees }} / {{ demande.qteFacesPrevues}}
              </span>
              <a @click="popUpSelectionFace = true"
                 v-if="demande.ligneCommande.ligneReseau.lignesCmdSelProduits.length > 0
                  || (demande.ligneCommande.lignesCmdSelOptionProduit
                    && demande.ligneCommande.lignesCmdSelOptionProduit.length > 0)">
                <b-icon icon="information"
                        type="is-success"
                        size="is-small">
                </b-icon>
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="column is-3 mgt-5">
        <div class="columns">
          <div class="column is-4">
            <b-field :label="$t('listeDemandeTempo.card.prixNet')"
                     custom-class="has-text-weight-light is-italic mgb-0 ellipsis">
              <p class="has-text-link has-text-weight-bold ellipsis">
                {{ demande.totalHtAvecLigneRemise | formatDevise }}
              </p>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field :label="$t('listeDemandeTempo.card.prixNetFace')"
                     custom-class="has-text-weight-light is-italic mgb-0 ellipsis">
              <p class="has-text-link has-text-weight-bold ellipsis">
                {{ demande.totalNetParFace | formatDevise }}
              </p>
            </b-field>
          </div>
          <div class="column is-4" v-if="afficherObjectif">
            <b-field :label="$t('listeDemandeTempo.card.objectif')"
                     custom-class="has-text-weight-light is-italic mgb-0 ellipsis">
              <p class="has-text-weight-bold ellipsis"
                v-if="disponibilite && disponibilite.objectif"
               :class="{'has-text-danger': !objectifValide, 'has-text-success': objectifValide}">
                {{ disponibilite.objectif | formatDevise }}
              </p>
              <p class="has-text-weight-bold ellipsis" v-else
                :class="{'has-text-danger': !objectifValide, 'has-text-success': objectifValide}">
                {{ 0.00 | formatDevise }}
              </p>
            </b-field>
          </div>
        </div>
      </div>
      <div class="column is-3 mgt-0_25em">
        <div class="columns is-multiline is-marginless width-100percent">
          <div class="ellipsis column is-12 is-paddingless">
              <span class="has-text-weight-light is-italic has-text-default">
                  {{ $t('listeDemandeTempo.card.etatSouhaite') }}
              </span>
            <span class="has-text-link has-text-weight-bold">
                {{ $t(getLibelleEtat(demande.etatSouhaite)) }}
              </span>
          </div>
          <div class="ellipsis column is-12 is-paddingless">
            <span class="has-text-weight-light is-italic has-text-default">
                {{ $t('listeDemandeTempo.card.etatObtenu') }}
            </span>
            <span class="has-text-link has-text-weight-bold">
                {{ $t(getLibelleEtat(demande.etatObtenu)) }}
              </span>
          </div>
          <div class="ellipsis column is-12 is-paddingless" >
            <span class="has-text-weight-light is-italic has-text-default">
                {{ $t('listeDemandeTempo.card.rang') }}
            </span>
            <span class="has-text-link has-text-weight-bold">
                {{ demande.rangOption }}
              </span>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="ellipsis column is-12 is-paddingless" v-if="societeActive.agences.length > 1">
          <span class="has-text-weight-light is-italic has-text-default">
              {{ $t('listeDemandeTempo.card.agence') }}
          </span>
          <span class="has-text-link has-text-weight-bold">
              {{ $t(getAgenceLibelle(demande.ligneCommande.produit.agenceId)) }}
            </span>
        </div>
        <b-field :label="$t('listeDemandeTempo.card.etatObtenuForce')"
                 v-if="checkPermissions(constantes.DEMANDE_TEMPO.maj)"
                 custom-class="has-text-weight-light is-italic mgb-0 ellipsis">
          <b-select :value="demande.etatObtenuReponse" @input="updateEtatObtenuReponse">
            <option v-for="etat in getListEtatObtenu" :key="etat.key" :value="etat.key">
              {{ $t(etat.libelle) }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <b-modal
      v-model="popUpSelectionFace"
      width="1200px"
      class="modal"
      has-modal-card>
      <pop-up-selection-face
        :ligneSelect="demande.ligneCommande"
        :display-column-logistique="false"
        :is-detail="true"
        :permissions="constantes.DEMANDE_TEMPO"
        :typeDcf="constantes.TYPE_DEVIS">
      </pop-up-selection-face>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { DEMANDE_TEMPO } from '@/configuration/permissionsBodacConf';
import { TYPE_DEVIS } from '@/configuration/devisConf';
import { BLOQUE, ETAT_OBTENU_REPONSE, ETAT_OBTENU } from '@/configuration/optionBlocage/optionBlocage';
import popUpSelectionFace from '@/components/devisCommandeFacture/facesSelectInReseauTempo/p_selectFaces';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { CATEGORIE_REGROUPEMENT, CATEGORIE_LOCATION } from '@/configuration/catalogue/produitConf';
import getDisponibilite from '@/services/devisCommandes/getDisponibiliteTempo';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    demande: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        DEMANDE_TEMPO,
        CATEGORIE_REGROUPEMENT,
        CATEGORIE_LOCATION,
        TYPE_DEVIS,
      },
      popUpSelectionFace: false,
      disponibilite: null,
    };
  },
  components: {
    popUpSelectionFace,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      societeActive: 'societeActive',
    }),
    getListEtatObtenu() {
      let listEtatObtenu = cloneDeep(ETAT_OBTENU_REPONSE);
      if (this.demande.qteFacesSouhaitees === 0) {
        listEtatObtenu = listEtatObtenu.splice(4, 2);
        listEtatObtenu.unshift(ETAT_OBTENU_REPONSE[0]);
        return listEtatObtenu;
      }
      if (this.demande.etatSouhaite !== BLOQUE) listEtatObtenu.splice(7, 1);
      return listEtatObtenu;
    },
    isReseauLocation() {
      return this.demande.ligneCommande.lignesCommande.filter((el) => {
        return el.typeProduit === this.constantes.CATEGORIE_LOCATION;
      }).length > 0;
    },
    afficherObjectif() {
      return this.isReseauLocation
        && this.demande.ligneCommande.typeProduit === this.constantes.CATEGORIE_REGROUPEMENT
        && this.parametresInterne(
          PARAMETRES_INTERNE_KEYS.activationYield.key,
        );
    },
    objectifValide() {
      if (!this.disponibilite) return false;
      return this.demande.totalNetParFace >= this.disponibilite.objectif;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    getLibelleEtat(codeEtat) {
      const etatFind = ETAT_OBTENU.find((etat) => { return etat.key === codeEtat; });
      return etatFind ? etatFind.libelle : '';
    },
    getAnneeSemaine(anneeSemaine) {
      return this.$i18n.t('listeDemandeTempo.card.anneeSemaine', {
        week: anneeSemaine.toString().substring(4, 6),
        year: anneeSemaine.toString().substring(0, 4),
      });
    },
    updateEtatObtenuReponse(etat) {
      this.$emit('updateEtatObtenuReponse', this.demande.ligneId, etat);
    },
    getAgenceLibelle(agenceId) {
      let libelleAgence = '';
      this.societesInformations.forEach((societe) => {
        societe.agences.forEach((agence) => {
          if (agence.id === agenceId) libelleAgence = agence.libelle;
        });
      });
      return libelleAgence;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.activationYield.key]);
      const dateDebut = this.demande.ligneCommande.dateDebut;
      const dateFin = this.demande.ligneCommande.dateFin;
      this.disponibilite = await getDisponibilite(this.demande, dateDebut, dateFin);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
